import { Components, Theme } from '@mui/material/styles';

export const muiBreadcrumbsOverride: Components<Theme>['MuiBreadcrumbs'] = {
  styleOverrides: {},
};
